<template>  
  <v-container grid-list-lg class="ma-0 pa-0">
    <v-layout row>
      <v-flex xs12 md4>
        <form @submit.prevent="onsubmit">
        <v-card>                    
          <v-card-text>                  
            <v-layout row>
              <v-flex xs12>
                <v-text-field outlined dense
                label="Name"
                v-model="fm.name"
                append-icon="room"
                type="text"
                :error="!!error.name.length"
                :error-messages="error.name"
              ></v-text-field>

                <v-radio-group v-model="fm.level" row>
                  <v-radio label="provinsi" :value="1"></v-radio>
                  <v-radio label="kabupaten/kota" :value="2"></v-radio>
                </v-radio-group>
              </v-flex>
              <v-flex xs12>
                <v-autocomplete outlined dense v-if="fm.level == 1"
                  v-model="fm.node_id"
                  label="Propinsi"
                  :items="propinsies"
                  item-text="name"
                  item-value="id" 
                  :loading="propinsiLoading"   
                  autocomplete="off"              
                >                 
                </v-autocomplete>
                <v-autocomplete outlined dense v-else
                  v-model="fm.idpro"
                  label="Propinsi"
                  :items="propinsies"
                  item-text="name"
                  item-value="id" 
                  :loading="propinsiLoading"   
                  autocomplete="off"              
                >                 
                </v-autocomplete>                                   
              </v-flex>
              <v-flex xs12>
                <v-autocomplete outlined dense v-if="fm.level==2"
                  v-model="fm.node_id"
                  label="Kabupaten"
                  :items="kabupatens"
                  item-text="name"
                  item-value="id"
                  :loading="kabupatenLoading"
                  autocomplete="off"
                >
                 
                </v-autocomplete>   
                <v-autocomplete outlined dense v-else
                  multiple
                  v-model="fm.node_ids"
                  label="Dapil"
                  :items="kabupatens"
                  item-text="name"
                  item-value="id"
                  :loading="kabupatenLoading"
                  autocomplete="off"
                >
                 
                </v-autocomplete>                                   
              </v-flex>
              <v-flex xs12 v-if="fm.level == 2">
                <v-autocomplete outlined dense
                  :multiple="fm.level==2"
                  v-model="fm.node_ids"
                  label="Dapil"
                  :items="kecamatans"
                  item-text="name"
                  item-value="id"
                  :loading="kecamatanLoading"
                  autocomplete="off"
                >
                  
                </v-autocomplete>                                   
              </v-flex>
              <v-flex xs6 style="display: none;">
                <v-autocomplete outlined dense
                  v-model="fm.idkel"
                  label="Kelurahan"
                  :items="kelurahans"
                  item-text="name"
                  item-value="id"
                  :loading="kelurahanLoading"
                  autocomplete="off"
                >
                  <template v-slot:item="data">
                    <template>
                      <v-list-item-content>
                        <v-list-item-title v-html="data.item.name"></v-list-item-title>
                      </v-list-item-content>
                    </template>
                  </template>
                </v-autocomplete>                                   
              </v-flex>
            </v-layout>
            
          </v-card-text>
          <v-card-actions class="pa-4">
            <v-spacer />
            <v-btn type="submit" :color="isUpdate?'blue':'green'" :loading="loading" dark>{{isUpdate?'update':'create'}}</v-btn>
          </v-card-actions>
        </v-card>
        </form>   
      </v-flex>            
    </v-layout>
  </v-container>    
</template>

<script>
import { debounce } from 'lodash'
import model from '@/app/models/master/Dapil'

export default {
  data : () => ({  
    fm:{idpro:null,idkab:null,idkec:null,idkel:null,no: null, name: null, level:1, node_id:null, node_ids:[]},
    error:{  name : [], node_id:[], level:[], node_ids:[]},
    loading: false,
    isUpdate: false,    
    mode: 0,        
    parents: [],
    propinsies:[], propinsiLoading :false,
    kabupatens:[], kabupatenLoading:false,    
    kelurahans:[], kecamatanLoading:false,
    kecamatans:[], kelurahanLoading:false,
  }),
  computed:{
    levels(){
      let obj = this.$store.getters.DICTIONS.RegionLevel;
      return Object.keys(obj).map(function(key) { return {id:parseInt(key), name: obj[key]}; });
    }
  },
  watch:{
    'fm.idpro'(newId, oldId){
      this.kabupatenLoading = true;
      model.nodes({level:2, parent_id:newId}).then(res=>{
        this.kabupatens = res.data;
        this.kabupatenLoading = false;
      });  
    },
    'fm.idkab'(newId, oldId){
      this.kecamatanLoading = true;
      model.nodes({level:3, parent_id:newId}).then(res=>{
        this.kecamatans = res.data;
        this.kecamatanLoading = false;
      });  
    },
    'fm.idkec'(newId, oldId){
      this.kelurahanLoading = true;
      model.nodes({level:4, parent_id:newId}).then(res=>{
        this.kelurahans = res.data;
        this.kelurahanLoading = false;
      });  
    },
    'fm.node_id'(nid){
      if(this.fm.level == 1){
        this.fm.idpro = nid
      } else if(this.fm.level == 2){
        this.fm.idkab = nid
      }
    }
  }, 
  mounted(){
    this.propinsiLoading = true;
    model.nodes({level:1}).then(res=>{
      this.propinsies = res.data;
      this.propinsiLoading = false;
    });

    if(this.$route.query.id){
      this.isUpdate = true;
      model.view({id:this.$route.query.id}).then(data=>{                
        Object.assign(this.fm, data);
      })
    }
  },
  methods: {
    search: debounce(function (e) {      
      this.readParents(e.target.value)
    }, 800),

    readParents(term){
      model.all({q:term}).then(res=>{
        this.parents = res.data;
      })
    },

    onsubmit(){
      this.loading = true;  this.clearErrors();
      if(this.isUpdate){        
        model.update(this.fm, {id:this.fm.id}).then(res=>{this.responseSubmit(res)})
      } else {        
        model.create(this.fm).then(res=>{this.responseSubmit(res)})
      }
    },

    responseSubmit(res){
      this.loading = false;
      if(res.status === 200){
        window.getApp.$emit('showSnackbar', {text :'Data has been saved successfully', color: 'green', show:true});            
        this.$router.replace({name:'master/dapil'})                
      } else {
        this.validate(res.data);
      }
    },

    validate(data){      
      for(var i in data){        
        if(Array.isArray(this.error[data[i]['field']])){          
          this.error[data[i]['field']].push(data[i]['message']);
        }        
      }
    },

    clearErrors(){
      this.error.name    = [];
      this.error.type    = [];
      this.error.address = [];
      this.error.email   = [];
      this.error.node_id = [];      
    }
  },
}
</script>

<style>
.ramping td, .ramping th {
    padding: 0 5px;
}
</style>